import { render, staticRenderFns } from "./zsfaProcess-dialog.vue?vue&type=template&id=6689dec2&scoped=true"
import script from "./zsfaProcess-dialog.vue?vue&type=script&lang=js"
export * from "./zsfaProcess-dialog.vue?vue&type=script&lang=js"
import style0 from "./zsfaProcess-dialog.vue?vue&type=style&index=0&id=6689dec2&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689dec2",
  null
  
)

export default component.exports